import type { SVGProps } from 'react';

export const Close = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' fill='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            d='m13.414 12 5.293-5.293a1 1 0 1 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 1 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.414 12z'
            fillRule='evenodd'
        />
    </svg>
);
